import apiClient from './apiClient';
import { withActingAs } from './actingAs';
import type { ApiResponse, OrdersApiResponse } from '../types';
import { mockOrdersResponse } from './mockData/ordersMock';

const API_TYPE = 'api' as const;
const USE_MOCK = false;

function unwrap<T>(response: ApiResponse<T> | T, fallbackError: string): T {
  if ((response as any)?.success !== undefined) {
    const wrapped = response as ApiResponse<T>;
    if (!wrapped.success || !wrapped.data) {
      throw new Error(wrapped.message || fallbackError);
    }
    return wrapped.data;
  }
  return response as T;
}

class OrdersService {
  async fetchOrderbook(): Promise<OrdersApiResponse> {
    if (USE_MOCK) return mockOrdersResponse;

    // Phase 3.5: order_viewer accepts ?acting_as= as a query param even though
    // the request body is POSTed empty. Append when set.
    const qp = withActingAs(new URLSearchParams());
    const url = qp.toString() ? `/orders/fetch-orderbook?${qp.toString()}` : '/orders/fetch-orderbook';
    try {
      const response = await apiClient.post<ApiResponse<OrdersApiResponse> | OrdersApiResponse>(
        url,
        {},
        undefined,
        API_TYPE
      );
      return unwrap(response, 'Failed to fetch orderbook');
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch orderbook');
    }
  }
}

const ordersService = new OrdersService();
export default ordersService;
export { OrdersService };
